<template>
  <!--FOOTER START-->
  <footer class="container footer">
    <div class="d-flex align-items-center justify-content-center flex-wrap flex-column">
      <span class="footer__block-info">{{ locale[language].s1 }}:</span>
      <div class="footer__block-logo d-flex justify-content-center align-items-center flex-wrap">
        <img src="assets/img/logotip-belkart_internetparol_itog.svg" alt="belkart internet password" width="65"
             height="36">
        <img src="assets/img/msc.svg" alt="mastercard secure code" width="57" height="36">
        <img src="assets/img/vb_visa.svg" alt="verified by visa" width="50" height="36">
        <img src="assets/img/icon_ipay.svg" alt="apple pay logo" width="47" height="27">
        <img src="assets/img/pci_dss_gray.svg" alt="pci dss logo" width="57" height="36">
      </div>
      <div class="d-flex flex-column footer__block-contact">
        <a href="mailto:support@webpay.by" :style="cssLinkColor">support@webpay.by</a>
        <a href="tel:+375172198434" :style="cssLinkColor">+375 17 219 84 34</a>
      </div>
    </div>
  </footer>
  <!--FOOTER END-->
</template>

<script>

export default {
  name: "Footer",
  data() {
    return {
      showModal: false,
      locale: {
        'russian': {
          s1: 'Техническая поддержка',
          s2: 'Операции защищены международным стандартом',
          s3: 'безопасности',
          s4: 'при работе с платежными карточками',
        },
        'english': {
          s1: 'Technical support',
          s2: 'Transactions are protected by the international',
          s3: 'safety',
          s4: 'standard for credit cards',
        }
      },
    }
  },
  methods: {
    closeModal: function () {
      this.showModal = false;
    },
  },
  props: [
    'siteBrandColor',
    'language'
  ],
  computed: {
    cssLinkColor: function () {
      return {
        '--color': this.siteBrandColor
      }
    }
  },
  components: {
  },
}
</script>

<style scoped>
.support_phone, .support_email, .footer__block-info > a {
  color: var(--color)
}
</style>
